import React from 'react';
import { Link } from '@remix-run/react';
// Lazy load FooterLocations to reduce initial bundle size
const FooterLocations = React.lazy(() => import('./footer-locations'));

export default function Footer() {
  return (
    <footer
      data-wpr-lazyrender="1"
      className="font-helvetica-neue w-full bg-[#2552ba] py-6 text-white lg:py-0 lg:pt-[88px]"
    >
      <div className="mx-auto w-full max-w-[106rem] bg-[url('/assets/images/backgrounds/footerbg.webp')] bg-center bg-no-repeat px-4">
        {/* Rewards Section */}
        <section className="flex flex-col items-center justify-center gap-2 text-center md:gap-5 lg:gap-6">
          <h3 className="text-3xl font-extrabold tracking-wide md:text-4xl lg:text-5xl">
            Stack Up Rewards With Every Purchase
          </h3>
          <p className="text-lg font-bold tracking-wide">
            Earn points, get exclusive rewards, and enjoy members-only hookups!
          </p>
          <Link
            to="/register"
            className="my-3 rounded-full bg-red-700 px-10 py-2.5 text-lg font-bold text-white uppercase shadow-lg hover:bg-red-800 focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
            aria-label="Join Now - Catalyst Rewards Program"
          >
            Join Now
          </Link>
        </section>

        {/* Social Media Links */}
        <nav
          className="flex items-center justify-center gap-2 py-6"
          aria-label="Social Media Links"
        >
          <a
            href="https://x.com/Catalyst__Cares"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Catalyst on X (opens in a new window)"
            className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-[#2b69d0] hover:bg-[#fbd100] focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none md:h-[70px] md:w-[70px]"
          >
            <svg
              className="size-10 fill-current text-[#2552ba] md:text-2xl"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              aria-hidden="true"
            >
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/catalyst.cares/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Follow Catalyst on Instagram (opens in a new window)"
            className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-[#2b69d0] hover:bg-[#fbd100] focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none md:h-[70px] md:w-[70px]"
          >
            <svg
              className="size-10 fill-current text-[#2552ba] md:text-2xl"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              aria-hidden="true"
            >
              <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
            </svg>
          </a>
          <a
            href="/contact"
            aria-label="Contact Catalyst"
            className="flex h-[50px] w-[50px] items-center justify-center rounded-full bg-[#2b69d0] hover:bg-[#fbd100] focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none md:h-[70px] md:w-[70px]"
          >
            <svg
              className="size-10 fill-current text-[#2552ba] md:text-2xl"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              aria-hidden="true"
            >
              <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
            </svg>
          </a>
        </nav>

        {/* Footer Navigation */}
        <div className="mx-auto mt-8 grid w-full max-w-[106rem] grid-cols-2 justify-evenly gap-6 px-6 md:flex md:py-4 lg:py-8">
          {/* Column 1 */}
          <ul className="flex flex-col gap-2 lg:gap-2">
            <li>
              <h3 className="flex items-center gap-2 text-xl font-bold md:text-2xl">
                Shop
                <i className="fa-sharp fa-solid fa-angles-right" aria-hidden="true"></i>
              </h3>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/shop"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Shop All Products
              </Link>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/brand"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Featured Brands
              </Link>
            </li>

            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/deals"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Deals
              </Link>
            </li>
          </ul>
          {/* Column 2 */}
          <ul className="flex flex-col gap-2 lg:gap-2">
            <li>
              <h3 className="flex items-center gap-2 text-xl font-bold md:text-2xl">
                Community
                <i className="fa-sharp fa-solid fa-angles-right" aria-hidden="true"></i>
              </h3>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://catalyst-cares.com/"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Catalyst Cares
              </a>
            </li>
          </ul>
          {/* Column 3 */}
          <ul className="flex flex-col gap-2 lg:gap-2">
            <li>
              <h3 className="flex items-center gap-2 text-xl font-bold md:text-2xl">
                Company
                <i className="fa-sharp fa-solid fa-angles-right" aria-hidden="true"></i>
              </h3>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/about"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                About Catalyst
              </Link>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/contact"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Contact
              </Link>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/rewards"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Rewards
              </Link>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/events"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Events
              </Link>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/news"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                News
              </Link>
            </li>
            <li className="text-base hover:text-[#fbd100] lg:text-lg">
              <Link
                to="/accessibility"
                className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                Accessibility
              </Link>
            </li>
          </ul>
          <div className="flex flex-col gap-2 lg:flex-row">
            {/* Column 4 */}
            <ul className="flex flex-col gap-2 lg:gap-2">
              <li>
                <h3 className="flex items-center gap-2 text-xl font-bold md:text-2xl">
                  Categories
                  <i className="fa-sharp fa-solid fa-angles-right" aria-hidden="true"></i>
                </h3>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/flower"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Flower
                </Link>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/vapes"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Vapes
                </Link>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/prerolls"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Pre-Rolls
                </Link>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/edibles"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Edibles
                </Link>
              </li>
            </ul>
            {/* Column 5 */}
            <ul className="flex flex-col gap-2 lg:gap-2 lg:pt-10">
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/concentrates"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Concentrates
                </Link>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/tinctures"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Tinctures
                </Link>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/topicals"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Topicals
                </Link>
              </li>
              <li className="text-base hover:text-[#fbd100] lg:text-lg">
                <Link
                  to="/category/merch"
                  className="focus-visible:ring-2 focus-visible:ring-[#ffd100] focus-visible:ring-offset-2 focus-visible:outline-none"
                >
                  Merch
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <React.Suspense
        fallback={
          <div className="bg-[#2552ba] py-8 text-center text-white">Loading locations...</div>
        }
      >
        <FooterLocations />
      </React.Suspense>
    </footer>
  );
}
